module.exports = __webpack_public_path__ + "static/media/logo.215ba81c.png";